/* unplugin-vue-components disabled */import { render } from "./AltasBajasDashboard.vue?vue&type=template&id=c10e8292"
import script from "./AltasBajasDashboard.vue?vue&type=script&lang=js"
export * from "./AltasBajasDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__